<template>
  <Modal class="long-modal" width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" :loading="loading">
    <div slot="header" class="modal-header">{{isCompanyUpdate ? '变更入住人':'添加入住人'}}<span>{{projectName}}</span><span class="dot">.</span><span>{{stockNumber}}</span></div>
    <Form :model="formData" :label-width="82"  :rules="formRules" ref="formData">
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="手机号" :class=" {'ivu-form-item-error':phoneNumErr}">
            <Input v-model="formData.phoneNum" @on-blur="validatePhone"></Input>
            <div v-show="phoneNumErr"  class="ivu-form-item-error-tip">输入正确的联系方式</div>
          </FormItem>
        </Col>
        <Col span="16" v-if="haSignUp===2">
          <img height="30" title="点击刷新" :src="`data:image/png;base64,${imgVerifycode}`" @click="getImgVerifycode" />
          <Input class="w-80" :class=" {'ivu-form-item-error':imgCodeErr}" v-model="imgCodeInput" placeholder="输入图形验证码" @on-blur="sendSmCode"></Input>
          <Input v-if="showSmInput" class="w-80" v-model="smCodeInput" placeholder="输入短信验证码" @on-blur="verifySmCcode"></Input>
          <span v-if ="validateSmCode===1"><Icon type="android-done" color="#85CC7A" class="icon"></Icon></span>
          <span v-if ="validateSmCode===2 && showSmInput" class="error-color">短信验证码错误</span>
        </Col>
        <Col span="16" v-if="haSignUp===1">
          <span style="line-height:32px">该手机号已注册</span>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7" >
          <FormItem label="姓名" prop="name">
            <Input v-model="formData.name"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <div class="flex">
             <FormItem label="证件信息" prop="certType" class="certType">
            <Select v-model="formData.certType" style="width: 80px">
                <Option v-for="item in cardTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
          </FormItem>
          <FormItem label="" prop="certNum" class="certNum">
             <Input v-model="formData.certNum" style="width: 140px"></Input>
          </FormItem>
          </div>
        </Col>
        <Col span="7">
          <FormItem label="性别" prop="sex">
            <RadioGroup v-model="formData.sex">
              <Radio v-for=" (item,i) in genderTypeList" :key="`gender${item.value}`" :label="item.value">
                  <span>{{item.text}}</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="出生年月" prop="birthday">
            <DatePicker placeholder="yyyy-mm-dd" v-model="formData.birthday" type="date" style="width: 100%"></DatePicker>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem label="工作类型" prop="jobCode">
            <Select v-model="formData.jobCode" style="width: 220px">
              <Option v-for="item in jobTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="国籍" prop="nationality">
            <Input v-model="formData.nationality"></Input>
          </FormItem>
        </Col>
        </Row>
        <Row :gutter="16">
        <Col span="7">
          <FormItem label="婚姻状况" prop="marriage">
            <Select v-model="formData.marriage">
              <Option v-for="item in marryStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <div class="ivu-form-item-required ivu-form-item ">
            <span style="width:82px;" class="inline-b ivu-form-item-label">证件照片</span>
            <div style="display:flex;">
              <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.certPic1"  :src="formData.certPic1" @click="showImg(formData.certPic1)"/>
              <Upload
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccessF"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.certPic1" class="upload" :class="{error: !validateLicense1}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.certPic1 && !validateLicense1" class="error-color" href="javascript:;">请上传证件照</a>
                <a v-if="formData.certPic1" href="javascript:;">修改</a>
              </Upload>
              </div>
             <div class="upload-wrap">
              <img class="imgwidth" v-if="formData.certPic2"  :src="formData.certPic2" @click="showImg(formData.certPic2)"/>
              <Upload
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccessB"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
              >
                <div v-if="!formData.certPic2" class="upload" :class="{error: !validateLicense2}">
                  <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
                  <p>点击上传图片</p>
                </div>
                <a v-if="!formData.certPic2 && !validateLicense2" class="error-color" href="javascript:;">请上传证件照</a>
                <a v-if="formData.certPic2" href="javascript:;">修改</a>
              </Upload>
            </div>
            </div>
          </div>
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="紧急联系人" prop="emergencyContact">
              <Input  v-model="formData.emergencyContact" ></Input>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="关系" prop="relationshipCode">
            <Select v-model="formData.relationshipCode">
              <Option v-for="item in contractsRelList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>

          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="联系电话" prop="emcyCntPhone">
              <Input v-model="formData.emcyCntPhone" ></Input>
          </FormItem>
        </Col>
      </Row>
      <div style="height:48px;">
        <span class="inline-b ivu-form-item-label title">合住人</span>
        <a v-if="!hasRoomate" href="javascript:;" class="inline-b ivu-form-item-label" style="width:82px; height:32px; color:#CFA868" @click="addRoomate">添加+</a>
      </div>
      </Form>
      <div v-if="hasRoomate">
        <Form :model="sharerForm" :label-width="82"  :rules="sharerRules" ref="sharerForm">
          <Row :gutter="16">
            <Col span="6" >
              <FormItem label="姓名" prop="name">
                <Input v-model="sharerForm.name"></Input>
              </FormItem>
            </Col>
            <Col span="7" >
              <FormItem label="手机号" prop="mobile">
                <Input v-model="sharerForm.mobile"></Input>
              </FormItem>
            </Col>
            <Col span="10" >
              <div class="flex">
                <FormItem label="证件信息" prop="certType" class="certType">
                <Select v-model="sharerForm.certType" style="width: 80px">
                    <Option v-for="item in cardTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
                  </Select>
              </FormItem>
              <FormItem label="" prop="certNum" class="certNum">
                <Input v-model="sharerForm.certNum" style="width: 140px"></Input>
              </FormItem>
              </div>
            </Col>
            <Col span="1">
              <Icon class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="deleteRoommate"></Icon>
            </Col>
          </Row>
        </Form>
      </div>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">
import { getBaseUrl } from "@/utils/public";
import { getToken } from "@/utils/auth";
import { formatDateTime } from "@/utils/format";
import { addCondition, toAddCheckPhone, getImgVerifycode, sendSmsVerifycodeUrl, verifySmsVerifycode, addRenter, validIdCardNumber } from "api/occupancy";

export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
    projectName: {
      type: String,
      default: ""
    },
    projectFid: {
      type: String,
      default: ""
    },
    stockNumber: {
      type: String,
      default: ""
    },
    contractId:{
      type:String,
      default:''
    },
    isCompanyUpdate:{
      type:Boolean,
      default:false
    }
  },
  created() {
    // this.getProjectConfigInfo()
    this.baseUrl = getBaseUrl();
    this.token = getToken();
    this.initData()
  },
  watch: {
    n(val) {
      this.loading = false;
      this.clearForm()
      this.formData.contractId = this.contractId
      this.phone=''
      this.show = true;
      this.imgVerifycode = ''
      this.imgCodeInput  = ''
      this.showSmInput = false
      this.imgCodeErr = false

      this.validateSmCode = 0
      this.smCodeInput = ''

    },
    // haSignUp(val){
    //   if(val===2){
    //     this.getImgVerifycode()
    //   }
    // },
    contractId(val){
      this.formData.contractId = val
    },
    phone(val){
      if(!val) return
      if(this.renterInfo.uid) {
          this.haSignUp = 1
          for (let key in this.renterInfo) {
            if( key === 'job'||key === 'relationship'|| key==='contractId') continue
            if(this.renterInfo[key]){
              this.formData[key] = this.renterInfo[key]
            }
          }
          this.formData.jobCode = this.renterInfo.job
          this.formData.relationshipCode = this.renterInfo.relationship
          if(this.formData.certType === 1 && this.formData.certNum) {
             validIdCardNumber(this.formData.certNum).then( res => {
                // 交验身份证信息，填充出生年月
                this.formData.birthday = formatDateTime(res.data.birthday,false)
              })
          }
          // if(this.formData.sharerEntities.length > 0) {
          //   this.hasRoomate = true
          //   this.showSmInput = this.this.formData.sharerEntities[0]
          // }
        } else {
          this.haSignUp = 2
          this.imgCodeInput = ''
          this.validateSmCode = 0
          this.smCodeInput = ''
          this.showSmInput =false
          this.imgCodeErr = false
          this.getImgVerifycode()
        }

    },
    // renterInfo:{
    //   deep:true,
    //   handler(val){
    //     if(val.uid) {
    //       this.haSignUp = 1
    //       for (let key in val) {
    //         if( key === 'job'||key === 'relationship'|| key==='contractId') continue
    //         if(val[key]){
    //           this.formData[key] = val[key]
    //         }
    //       }
    //       this.formData.jobCode = val.job
    //       this.formData.relationshipCode = val.relationship
    //       if(this.formData.certType === 1 && this.formData.certNum) {
    //          validIdCardNumber(this.formData.certNum).then( res => {
    //             // 交验身份证信息，填充出生年月
    //             this.formData.birthday = formatDateTime(res.data.birthday,false)
    //           })
    //       }
    //       // if(this.formData.sharerEntities.length > 0) {
    //       //   this.hasRoomate = true
    //       //   this.showSmInput = this.this.formData.sharerEntities[0]
    //       // }
    //     } else {
    //       this.haSignUp = 2
    //     }
    //   }
    // }
  },
  data() {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择出生日期'));
      }
      callback();
    }
    const validatPhone = (rule, value, callback) => {
      let pattern = /^1\d{10}$/;
      if (!pattern.test(value)) {
        callback(new Error("输入正确的联系方式"));
      }
      callback();
    };

    const validatCertNum = (rule, value, callback)=>{
      if(this.formData.certType===1){
        validIdCardNumber(value).then( res => {
          // 交验身份证信息，填充出生年月
          this.formData.birthday = formatDateTime(res.data.birthday,false)
          callback()
        }).catch(res => {
          callback('输入正确的证件号');
        })
      }else {
        if(value){
          callback();
        }else{
          callback('输入正确的证件号');
        }
      }
    }
    const validatCertNum1 = (rule, value, callback)=>{
      if(this.formData.certType===1){
        validIdCardNumber(value).then( res => {
          // 交验身份证信息，填充出生年月
          callback()
        }).catch(res => {
          callback('输入正确的证件号');
        })
      }else {
        if(value){
          callback();
        }else{
          callback('输入正确的证件号');
        }
      }
    }
    return {
      phone:'',
      phoneNumErr:false,
      renterInfo:null,
      baseUrl: "",
      token: "",
      loading: false,
      show: false,
      imgVerifycode:'',
      // imgCode:'',
      imgId:'',
      imgCodeInput:'',
      showSmInput:false,
      imgCodeErr:false,
      smCode:'',
      smCodeInput:'',
      validateSmCode:0,
      select1: "",
      validateLicense1:true,
      validateLicense2:true,
      cardTypeList: [],
      jobTypeList: [],
      genderTypeList:[],
      marryStatusList: [],
      contractsRelList:[],
      haSignUp: 0, // 0 未验证， 1已注册，2未注册
      hasRoomate: false,
      formData: {
        projectFid:'',
        uid:'',
        contractId:'',
        phoneNum:'',
        name: '',
        certType: '',
        certNum: '',
        sex: '',
        birthday: '',
        birthdayYear:'',
        birthdayMonday:'',
        //job:'',
        jobCode: '',
        nationality: '',
        certPic1: '',
        certPic2: '',
        marriage: '',
        emergencyContact: '',
        //relationship: '',
        relationshipCode:'',
        emcyCntPhone: '',
       // sharerEntities:[]

      },
      formRules: {
        //phoneNum: [{ required: true, validator: validateContactPhone, trigger: "blur" }],
        name: [{ required: true,message: "请输入姓名",type: "string",trigger: "blur"}],
        certType:[{required: true,message: "请选择证件类型",type: "number",trigger: "change"}],
        certNum: [{required: true,validator:validatCertNum, message:'请输入正确的证件号',type: "string",trigger: "blur"}],
        sex: [{required: true,message: "请选择性别",type: "number",trigger: "change"}],
        birthday: [ { required:true,validator:validateDate, trigger:'change' }],
        jobCode: [{required: true,message: "请选择工作类型",type: "number", trigger: "change"}],
        nationality: [ {required: true,message: "请输入国籍",type: "string",trigger: "blur"}],
        marriage: [{ required: true,message: "请选择婚姻状况",type: "number",trigger: "change"}],
        emergencyContact: [ {required: true,message: "请输入紧急联系人",type: "string", trigger: "blur" } ],
        relationshipCode: [ { required: true, message: "请输入紧急联系人关系", type: "number", trigger: "change"}],
        emcyCntPhone: [{ required: true, validator: validatPhone, trigger: "blur" }]
      },
      sharerForm:{
        // contractFid:'',
        name: '',
        mobile: '',
        certType: '',
        certNum: ''
      },
      sharerRules:{
        name: [{ required: true,message: "请输入姓名",type: "string",trigger: "blur"}],
        mobile: [{ required: true, validator: validatPhone, trigger: "blur" } ],
        certType:[{required: true,message: "请选择证件类型",type: "number",trigger: "change"}],
        certNum: [{required: true,validator:validatCertNum1,type: "string",trigger: "blur"}],
      }

    };
  },
  computed: {},
  methods: {
    addRoomate() {
      this.hasRoomate = true;
    },
    close() {
      this.show = false;
    },
    checkPhone(phoneNum){
      let params = {
        phoneNum:phoneNum,
        contractId:this.contractId,
        projectFid:this.projectFid
      }
      toAddCheckPhone(params).then( res => {
        this.renterInfo = res.data
        this.phone = phoneNum
        if(res.data.uid){
          this.formData.uid = res.data.uid
        }
      })
    },
    clearForm(){
      this.$refs["formData"].resetFields();
      // this.$refs["sharerForm"].resetFields();
      for(let key in this.formData){
          this.formData[key] = ''
      }
      for(let key in this.sharerForm){
        this.sharerForm[key] = ''
      }
      this.phoneNumErr = false
      this.validateLicense1 = true
      this.validateLicense2 = true
      this.hasRoomate = false
      this.haSignUp = 0
      this.validateSmCode = 0
    },
    deleteRoommate() {
      this.hasRoomate = false;
    },
    initData() {
      addCondition().then(res => {
        this.cardTypeList = res.data.cardType
        this.jobTypeList = res.data.jobType
        this.genderTypeList = res.data.genderType
        this.marryStatusList = res.data.marryStatus
        this.contractsRelList = res.data.contractsRel
      });
    },
    getImgVerifycode(){
      this.imgCodeErr = false
      this.imgCodeInput = ''
      this.showSmInput = false
      this.validateSmCode = 0
      this.smCodeInput = ''
      getImgVerifycode().then( res => {
        this.imgVerifycode = res.data.imgData
        this.imgId = res.data.imgId
        // this.imgCode = res.data.imgCode
      })
    },
    save() {
      this.$refs['formData'].validate(bool => {
        this.formData.projectFid = this.projectFid;
        let pattern = /^1\d{10}$/;
        this.phoneNumErr = pattern.test(this.formData.phoneNum) ? false : true
        if(!this.formData.certPic1){
          this.validateLicense1 = false
        }
        if(!this.formData.certPic2){
          this.validateLicense2 = false
        }
        let validateSharerForm = this.validateSharerForm()
        // console.log(bool,this.validateLicense1,this.validateLicense2,this.phoneNumErr,validateSharerForm)
        if(bool && this.validateLicense1 && this.validateLicense2 && !this.phoneNumErr && validateSharerForm) {
          let sharerAddDtos = []
          let data = null
          if(typeof this.formData.birthday === 'object'){
            this.formData.birthdayYear = this.formData.birthday.getFullYear()
            this.formData.birthdayMonday = this.formDataMonthDate(this.formData.birthday)
          } else if (typeof this.formData.birthday === 'string'){
            let birthday = this.formData.birthday.split('-')
            this.formData.birthdayYear = birthday[0]
            this.formData.birthdayMonday = birthday[1]+''+birthday[2]
          }

          if(this.hasRoomate){
            sharerAddDtos.push(this.sharerForm)
            // this.formData.sharerEntities[0] = this.sharerForm
          } else {
            sharerAddDtos.length = 0
            //this.formData.sharerEntities.length = 0
          }
          data = Object.assign({},{checkinAddDto:this.formData},{sharerAddDtos:sharerAddDtos})
          addRenter(data).then( res => {
            this.$Message.success('添加成功!');
            this.$emit('refresh')
            this.show = false
          })
        }
      })

    },
    formDataMonthDate(inputTime){
      var date = new Date(inputTime);
       var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return m+''+d
    },
    sendSmCode(){
      // if(this.imgCode.toLowerCase()===this.imgCodeInput.toLowerCase()){
        if(this.imgCodeInput) {
          // this.imgCodeErr = false
          // this.showSmInput = true
          let params = {
            phone:this.formData.phoneNum,
            type:1,
            imgId: this.imgId,
            imgVValue: this.imgCodeInput
          }
          sendSmsVerifycodeUrl(params).then( res => {
            // console.log(res)
            if(res.data.status === 'fail'){
               this.$Message.error(res.data.data)
              this.imgCodeErr = true
               this.showSmInput = false
            }else if(res.data.status === 'success'){
              this.showSmInput = true
              this.smCode = res.data.data
              this.imgCodeErr = false

            }
          })
        } else{
           this.showSmInput = false
        }

      // }else {
      //   this.imgCodeErr = true
      //   this.showSmInput = false
      // }
    },
    validateSharerForm(){
      let result = true
      if(this.hasRoomate) {
        this.$refs['sharerForm'].validate(bool => {
          this.result = bool
        })
      }
      return result
    },
    verifySmCcode(){
      this.validateSmCode= 0
      // if(this.smCodeInput !== this.smCode) {
      if(!this.smCodeInput){
        this.validateSmCode= 2
        return
      }
      let params = {
        type:1,
        phone:this.formData.phoneNum,
        vcode:this.smCodeInput
      }
      verifySmsVerifycode(params).then( res => {
        if(res.data.status === 'success') {
          this.checkPhone(this.phone)
          this.validateSmCode= 1 // 短信验证码成功
        }else {
          this.$Message.error(res.data.data)
          this.validateSmCode= 2 // 短信验证码失败
        }
      })
    },
    handleSuccessF(response) {
      this.formData.certPic1 = response.data.url;
      this.validateLicense1 = true
    },
    handleSuccessB(response) {
      this.formData.certPic2 = response.data.url;
      this.validateLicense2 = true
    },
    handleFormatError() {
      this.$Message.error("请输入jpg,jpeg,png,格式的文件");
    },
    showImg(img) {
      this.$emit("show-img", img);
    },
    validatePhone(){
      let phoneNum = this.formData.phoneNum

       let pattern = /^1\d{10}$/;
      if (!pattern.test(phoneNum)) {
        this.phoneNumErr = true
      } else {
        if(phoneNum === this.phone) return
        this.checkPhone(phoneNum)
        this.phoneNumErr = false
        // 调接口查询手机号 是否注册  注册填充信息，未注册显示图片验证码和手机验证码
      }

    }
  }
};
</script>
<style scoped>
.imgwidth {
  width: 80px;
}
a {
  color: #cfa868;
}

img {
  vertical-align: middle;
}
.w-80 {
  width: 100px;
  margin-left: 8px;
  vertical-align: middle;
}
.icon{
    font-size: 18px;
    vertical-align:bottom;
    padding-left: 8px;
}
.delete-icon{
      padding-left: 0px;
}
 .imgwidth {
  width: 167px;
  height: 118px;
}
a {
  color: #CFA868;
}

.upload-wrap {
  display: inline-block;
  line-height: 1;
  padding: 10px 4px;
}
.upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }
  .ivu-upload {
    position: relative;

  }

  .ivu-upload  a {
    position :absolute;
    right: 0;
    bottom: -6px;
  }
  .upload.error {
    border-color:#F56356;
  }
  a.error-color {
    color:#F56356;
    bottom: -18px;

  }
  .title {
    font-size: 14px;
    font-weight: 600;
     margin-bottom: 0px;
  }


</style>

